import Vue from "vue";
import Vuex from "vuex";

import UserStore from "./modules/user";
import OrganisationStore from "./modules/organisation";
import InvoiceStore from "./modules/invoice";
import ClientStore from "./modules/client";
import MetaStore from "./modules/meta";
import TemplateStore from "./modules/template";
import FlashMessagesStore from "./modules/flash-message";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    UserStore,
    OrganisationStore,
    InvoiceStore,
    ClientStore,
    MetaStore,
    TemplateStore,
    FlashMessagesStore
  }
});
